import React, { useEffect, useRef } from 'react';
import './CatalogueMobileShowcase.css';

const CatalogueMobileShowcase = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('revealed');
                }
            });
        }, observerOptions);

        const elements = sectionRef.current.querySelectorAll('.scroll-reveal');
        elements.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    // Using local images that represent the MR showcase
    const images = [
        '/images/catalogueimage04.webp',
        '/images/catalogueimage05.webp',
        '/images/catalogueimage06.webp',
        '/images/catalogueimage07.webp' // Using available assets
    ];

    return (
        <div className="catalogue-showcase-container" ref={sectionRef}>
            <div className="catalogue-showcase-bg-ripples"></div>

            <div className="catalogue-images-stack">
                {images.map((img, index) => (
                    <div
                        key={index}
                        className="catalogue-showcase-image-wrapper scroll-reveal image-reveal"
                        style={{ transitionDelay: `${index * 0.15}s` }}
                    >
                        <img src={img} alt={`Showcase ${index + 1}`} className="catalogue-showcase-image" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CatalogueMobileShowcase;
